export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: 'Suche',
  marketplaceDetailsCurtainCopyOptionTitle: 'Link kopieren',
  marketplaceDetailsCurtainFlagOptionTitle: 'Melden',
  marketplaceDetailsCurtainCopiedAlertText: 'Link kopiert!',
  marketplaceDetailsFlagCurtainTitle: 'Melden',
  marketplaceReportedCurtainContent: 'Inhalt gemeldet',
  marketplaceAllItems: 'Alle Artikel',
  marketplaceWantToBuy: 'Möchte {item} von {appname} kaufen'
}
